<template>
  <el-dialog
    title="添加审批人"
    :visible.sync="addSupplierVisible"
    width="1080px"
    height="560px"
    :before-close="cancelHandle"
    :close-on-click-modal="false"
    class="select-products"
    append-to-body
  >
    <div class="search-box" v-if="currentIndex === 0">
      <el-form :model="cListQuery" ref="cListQuery" size="small" class="search-form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="姓名：" label-width="130px" prop="">
              <el-input
                v-model="cListQuery.realName"
                placeholder="请输入姓名"
                style="width: 100%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="登录名：" label-width="130px" prop="">
              <el-input
                v-model="cListQuery.memberName"
                placeholder="请输入登录名"
                style="width: 100%"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="search-btn">
        <div class="btn reset-btn" size="small" @click="handleReset">重 置</div>
        <div class="btn submit-btn" size="small" @click="handleSearch">
          搜 索
        </div>
      </div>
    </div>
    <div class="table-wrap">
      <div class="table-left">
        <div class="list-box">
          <el-table
            :data="tableData"
            max-height="252"
            height="252px"
            ref="tableData"
            border
            size="small"
            style="width: 100%"
            :header-cell-style="{ background: '#F5F5F5' }"
            v-loading="tableLoading"
          >
            <el-table-column
              prop="realName"
              label="姓名"
              min-width="240"
              align="center"
              :key="1"
            ></el-table-column>
            <el-table-column
              v-if="currentIndex === 0"
              prop="memberName"
              label="登录名"
              min-width="130"
              align="center"
              :key="2"
            ></el-table-column>
            <el-table-column
              prop="value"
              label="部门"
              width="100px"
              align="center"
              :key="3"
            ></el-table-column>
            <el-table-column
              prop="businessDirection"
              label="业务方向"
              width="100px"
              align="center"
              :key="4"
            ></el-table-column>

            <el-table-column
              prop="mobile"
              label="联系方式"
              width="150px"
              align="center"
              :key="5"
            ></el-table-column>
            <el-table-column label="操作" width="60" align="center" :key="7" fixed="right">
              <template #default="slotScope">
                <span class="add-sup" @click="addSelectedList(slotScope.row)">添加</span>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="pagination-box">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :pager-count="5"
            layout="total, prev, pager, next"
            :current-page="cListQuery.pageNum"
            :total="total"
            :page-size.sync="cListQuery.pageSize"
          ></el-pagination>
        </div>
      </div>
      <div class="table-center">
        <img :src="trigger" alt="" width="30" />
      </div>
      <div class="table-right">
        <div class="list-box">
          <el-table
            :data="selectedList"
            max-height="252"
            height="252px"
            border
            size="small"
            style="width: 100%"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              prop="realName"
              label="姓名"
              min-width="100"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="mobile"
              label="联系方式"
              min-width="100"
              align="center"
            ></el-table-column>
            <el-table-column label="操作" width="60" align="center" :key="11">
              <template #default="slotScope">
                <span @click="delCompany(slotScope.row)" class="del-btn">
                  删除
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-box">
          <el-pagination
            @size-change="fakeHandleSizeChange"
            @current-change="fakeHandleCurrentChange"
            :pager-count="5"
            layout="total, prev, pager, next"
            :current-page="currentPage"
            :total="selectedList.length"
            :small="true"
            :page-size.sync="pagesize"
          ></el-pagination>
        </div>
      </div>
    </div>

    <div slot="footer">
      <div class="submit-btn btn" type="primary" @click="setSelectCompany">
        确定
      </div>
    </div>
  </el-dialog>
</template>

<script>
import multipleSelection from "./multipleSelection/multipleSelection.js";
import Api from ".././../../api/authority/index.js";
export default {
  mixins: [multipleSelection],
  props: {
    addSupplierVisible: {
      type: Boolean,
      default: false,
    },
    companyTableList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  components: {},
  data() {
    return {
      pagesize: 10, //    每页的数据
      currentPage: 1, //初始页
      trigger: require("../../../../../assets/img//purchase/trigger.png"),
      tabArr: [{ tabName: "审批人" }],
      currentIndex: 0,

      cloneSupplierForm: {},

      // 公司列表参数
      tableLoading: false,
      tableData: [],
      total: 0,
      cListQuery: {
        realName: "",
        pageNum: 1,
        pageSize: 10,
        memberName: "",
      },
      detailTotal: 0,

      // 已选供应商列表
      selectedList: [],

      idKey: "orderId",
      // 内层dia
      detailVisible: false,
    };
  },
  watch: {
    // addSupplierVisible(oldVal,newVal) {
    //   if (oldVal) {
    //     this.cloneSupplierForm = {
    //       memberName: "",
    //       realName:'',
    //       pageNum: 1,
    //       pageSize: 10,
    //     };
    //     this.currentIndex = 0;
    //     this.getList(this.cListQuery);
    //     this.currentPage = 1;
    //     this.selectedList = this.companyTableList;
    //     if(this.$route.params.operateType){
    //       for(let i=0;i<this.selectedList.length;i++){
    //           this.$set(this.selectedList[i],'memberId',this.selectedList[i].nodeMemberId)
    //         this.$set(this.selectedList[i],'realName',this.selectedList[i].nodeMemberName)
    //         this.$set(this.selectedList[i],'email',this.selectedList[i].nodeMemberMail)
    //         this.$set(this.selectedList[i],'mobile',this.selectedList[i].nodeMemberPhone)
    //       }
    //     }
    //   }
    //   if(!newVal){
    //     this.selectedList.length = 0
    //   }
    // },
  },
  created() {
    this.cloneSupplierForm = {
      memberName: "",
      realName: "",
      pageNum: 1,
      pageSize: 10,
    };
    this.currentIndex = 0;
    this.getList(this.cListQuery);
    this.currentPage = 1;
    this.selectedList = this.companyTableList;
    console.log("this.selected", this.selectedList);
    if (this.$route.params.operateType) {
      for (let i = 0; i < this.selectedList.length; i++) {
        this.$set(this.selectedList[i], "memberId", this.selectedList[i].nodeMemberId);
        this.$set(this.selectedList[i], "realName", this.selectedList[i].nodeMemberName);
        this.$set(this.selectedList[i], "email", this.selectedList[i].nodeMemberMail);
        this.$set(this.selectedList[i], "mobile", this.selectedList[i].nodeMemberPhone);
      }
    }
  },
  methods: {
    // 前端假分页
    fakeHandleSizeChange: function(size) {
      this.pagesize = size;
      console.log(this.pagesize); //每页下拉显示数据
    },
    // 切换当前页码时
    fakeHandleCurrentChange: function(currentPage) {
      this.currentPage = currentPage;
    },
    delCompany(row) {
      const { memberId } = row;
      this.selectedList.some((item, i) => {
        if (item.memberId === memberId) {
          this.selectedList.splice(i, 1);
        }
      });
    },
    // 添加审核人员
    addSelectedList(row) {
      this.selectedList.push(row);
      const obj = {};
      this.selectedList = this.selectedList.reduce(function(item, next) {
        obj[next.memberId] ? "" : (obj[next.memberId] = true && item.push(next));
        return item;
      }, []);
    },
    // 获取全部 列表数据
    async getList(params) {
      this.tableLoading = true;
      let res = await Api.queryOrderAuditPage(params);
      if (res.code === "200") {
        this.tableLoading = false;
        const list = res.data?.records;
        this.tableData = [...list];
        this.$nextTick(() => {
          this.$refs.tableData.doLayout();
        });
        this.total = res.data?.total;
      }
    },

    // 搜索
    handleSearch() {
      this.cListQuery.pageNum = 1;
      if (this.currentIndex === 0) {
        this.getList(this.cListQuery);
      }
    },
    // 重置
    handleReset() {
      this.cListQuery = { ...this.cloneSupplierForm };
      if (this.currentIndex === 0) {
        this.getList(this.cListQuery);
      }
    },
    // 切换
    handleTab(index) {
      this.currentIndex = index;
      this.tableData = [];

      this.cListQuery = { ...this.cloneSupplierForm };
      if (this.currentIndex === 0) {
        this.getList(this.cListQuery);
      }
    },
    handleCurrentChange(val) {
      this.cListQuery.pageNum = val;
      if (this.currentIndex === 0) {
        this.getList(this.cListQuery);
      }
    },
    handleSizeChange(val) {
      this.cListQuery.pageNum = 1;
      this.cListQuery.pageSize = val;
      this.getList(this.cListQuery);
    },
    cancelHandle() {
      this.cListQuery = { ...this.cloneSupplierForm };
      this.$emit("update:addSupplierVisible", false);
    },
    // 点击确定 获取到选择的审批人
    setSelectCompany() {
      if (this.selectedList.length) {
        this.$emit("getSelectCompany", this.selectedList);
        this.$emit("update:addSupplierVisible", false);
        this.$set(this, "selectedList", []);
      } else {
        this.$message.warning("请添加审批人");
        return;
      }
    },
  },
};
</script>
<style lang="scss">
.el-dialog {
  .el-dialog__body {
    padding: 10px;
    .pagination-box {
      text-align: center;
      margin-top: 10px;
      .el-pagination {
        button {
          height: 30px;
          color: #999;
        }
        .el-select {
          .el-input__inner {
            border-radius: 0;
            height: 30px;
          }
        }
        .el-input__inner {
          border-radius: 0;
          height: 30px;
          color: #999;
        }
        .el-select-dropdown__item,
        .el-pagination__jump,
        .el-pagination__total {
          height: 28px;
          line-height: 28px;
          color: #999;
          float: right;
        }
        .el-pager {
          li {
            border-radius: 0;
            border: 1px solid #d9d9d9;
            line-height: 28px;
            text-align: center;
            margin-left: 10px;
            width: 40px;
            height: 30px;
            color: #999;
            &:first-child {
              margin-left: 0;
            }
            &.active {
              background: #2587ff;
              border: none;
              color: #fff;
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.select-products {
  /* ::v-deep  .el-dialog {
    height: 525px;
  } */

  .table-wrap {
    width: 100%;
    display: flex;
    .table-left {
      width: 520px;
    }
    .table-center {
      flex: 1;
      align-self: center;
      text-align: center;
    }
    .table-right {
      width: 450px;
    }
    .add-sup {
      color: #0064c8;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }

    .del-btn {
      color: #f0250f;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .search-form {
    ::v-deep .el-form-item {
      width: 100%;
      display: inline-block;
      margin-right: 10px;
      vertical-align: top;
    }
    ::v-deep .el-select {
      width: 100%;
    }
    ::v-deep .el-input {
      width: auto;
    }
    ::v-deep .el-input__inner {
      border-radius: 0;
    }
  }
  .search-box {
    background: #fff;
    ::v-deep .el-form-item--small.el-form-item {
      margin-bottom: 10px;
      margin-right: 20px;
    }
    .search-btn {
      display: flex;
      justify-content: center;
      margin-bottom: 10px;

      .btn {
        width: 80px;
        text-align: center;
        height: 30px;
        line-height: 27px;
        cursor: pointer;
      }

      .reset-btn {
        background: #e8efff;
        border: 1px solid #2587ff;
        color: #2587ff;
        margin-right: 30px;
        line-height: 27px;
        &:hover,
        :active {
          background-color: #126edf;
          color: #fff;
        }
      }
      .submit-btn {
        background: #2587ff;
        border: 1px solid #2587ff;
        color: #ffffff;
        &:hover,
        :active {
          background-color: #126edf;
        }
      }
    }
  }
  /* .list-box {
    max-height: 260px;
  } */

  .pagination-box {
    text-align: center;
    margin-top: 10px;
    ::v-deep .el-pagination {
      button {
        height: 30px;
        color: #999;
      }
      .el-select {
        .el-input__inner {
          border-radius: 0;
          height: 30px;
        }
      }
      .el-input__inner {
        border-radius: 0;
        height: 30px;
        color: #999;
      }
      .el-select-dropdown__item,
      .el-pagination__jump,
      .el-pagination__total {
        color: #999;
      }
      .el-pager {
        li {
          border-radius: 0;
          border: 1px solid #d9d9d9;
          line-height: 28px;
          text-align: center;
          margin-left: 10px;
          width: 40px;
          height: 30px;
          color: #999;
          &:first-child {
            margin-left: 0;
          }
          &.active {
            background: #2587ff;
            border: none;
            color: #fff;
          }
        }
      }
    }
  }
  ::v-deep .el-dialog__body {
    padding: 10px;
  }

  ::v-deep .el-dialog__footer {
    display: flex;
    justify-content: center;
    .btn {
      width: 80px;
      text-align: center;
      height: 30px;
      line-height: 27px;
      cursor: pointer;
    }

    .submit-btn {
      background: #2587ff;
      border: 1px solid #2587ff;
      color: #ffffff;
      &:hover,
      :active {
        background-color: #126edf;
      }
    }
  }
}
// 列表重置样式-开始
::v-deep .el-table__header .cell {
  .icon-question {
    height: 18px;
    width: 18px;
    line-height: 18px;
    text-align: center;
    border-radius: 50%;
    border: 1px solid #c5c5c5;
    color: #c5c5c5;
    display: inline-block;
    margin-left: 10px;
    &:hover {
      color: #fff;
      background-color: #c5c5c5;
    }
  }
}
::v-deep .el-table__row .cell {
  font-size: 12px;
  white-space: normal;
  padding-left: 6px;
  padding-right: 6px;
  .el-button {
    font-size: 12px;
  }
  .el-input__inner {
    padding: 0 6px;
  }
  .edit-info {
    color: #c0c4cc;
  }
}
::v-deep .el-table--small td,
::v-deep .el-table--small th {
  padding: 6px 0;
}
::v-deep .el-table--small .el-table-column--selection {
  .cell {
    padding-left: 10px;
    padding-right: 10px;
    .el-checkbox__inner {
      border-radius: 0;
    }
  }
}
// 列表重置样式-结束

.tab-content {
  display: flex;
  align-items: center;
  position: relative;
  margin-bottom: 10px;
  border-bottom: 1px solid #d9d9d9;
  .tab-btn {
    position: relative;
    width: 150px;
    height: 34px;
    line-height: 34px;
    white-space: nowrap;
    cursor: pointer;
    background: #fff;
    color: #606266;
    -webkit-appearance: none;
    text-align: center;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    font-weight: 500;
    padding: 0 20px;
    font-size: 14px;
    border: 1px solid #d9d9d9;
    border-bottom: 0;
    &:last-child {
      border-left: 1px solid #d9d9d9;
    }
    &:first-child {
      border-right: 0;
    }
    &.active {
      background: #f4f7ff;
      color: #0064c8;
      height: 34px;
      line-height: 34px;
      border-top: 0;
      &::after {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        content: "";
        width: 100%;
        height: 2px;
        background: #0064c8;
      }
    }
  }
}

::v-deep .el-dialog__header {
  background: #f5f5f5;
  height: 40px;
  padding: 0 20px;
  line-height: 40px;
  .el-dialog__headerbtn {
    top: 8px;
  }
  .el-dialog__title {
    font-size: 14px;
  }
}
</style>
